import * as React from "react";
import { forwardRef } from "react";
const SvgPipeCircle = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 19, viewBox: "0 0 20 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M19.4341 18.0197C13.7304 10.1655 5.71524 10.154 0 18.0197V0C5.70374 7.85414 13.7189 7.86564 19.4341 0V18.0197Z", fill: "#EDEDED" }));
const ForwardRef = forwardRef(SvgPipeCircle);
export default ForwardRef;
